export function CapitalizeFirstLetter(input: string, lowerCaseRest: boolean = false): string
{
    if (lowerCaseRest) {
        return input.charAt(0).toUpperCase() + input.toLowerCase().slice(1);
    }
    return input.charAt(0).toUpperCase() + input.slice(1);
}